import { ButtonLoader } from 'components/__new/common/form'
import FormDrawer from 'components/__new/common/form-drawer'
import useLoginInfo from 'hooks/useLoginInfo'
import useUrlQueryParams from 'hooks/useUrlQueryParams'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import * as approvalAction from 'store/entities/approvals/action'
import processParams from 'utils/processParams'
    
const DeleteWorkflow = ({isOpen, setIsOpen, loading, workflow}) => {
    const {userInfo} = useLoginInfo();
    const dispatch = useDispatch();
    const {urlQueryParams} = useUrlQueryParams();
    const {deletedApprovalWorkflowLoading, deletedApprovalWorkflow} = useSelector(s => s.entities.approvals)
    
    const deleteWorkflow = () => {
        const workflowId = workflow?.id;
        dispatch(approvalAction.deleteApprovalWorkflow(workflowId));
    }
    
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });
    
    const getWorkflows = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "search", "string", "", "keyword");
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");

        setListParams(params);
        dispatch(approvalAction.getApprovalWorkflows({...params, employerId: userInfo?.employer?._id}))
    }
    
    useEffect(() => {
        if (deletedApprovalWorkflow?.error === false) {
            toast.success(deletedApprovalWorkflow?.message)
            setIsOpen(false)
            getWorkflows();
            dispatch(approvalAction.resetDeletedWorkflow())
        }
    }, [dispatch, deletedApprovalWorkflow])
    
    return (
        <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                
                <FormDrawer.Title
                    title="Delete Workflow"
                    showCloseButton={true}
                    close={setIsOpen}
                />

                <div className="w-full">

                    <div className="my-7 text-ep-gray-600">
                        Are you sure you want to delete this workflow? <br /> This action cannot be undone.
                    </div>

                    <div className="w-full flex items-center justify-start pt-3">
                        <ButtonLoader loading={deletedApprovalWorkflowLoading} disabled={deletedApprovalWorkflowLoading} onClick={deleteWorkflow} type="button" className="btn bg-[#dc2626] text-white w-full mr-3">
                            Yes
                        </ButtonLoader>

                        <button disabled={loading} onClick={() => setIsOpen(false)} className="btn btn-transparent-primary w-full font-semibold">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </FormDrawer>
    )
}



export default DeleteWorkflow;